var map = {
	"./simpleWorker": 519244,
	"./simpleWorker.js": 519244,
	"node_modules/monaco-editor/esm/vs/base/common/worker/simpleWorker": 519244,
	"node_modules/monaco-editor/esm/vs/base/common/worker/simpleWorker.js": 519244
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 243941;
module.exports = webpackAsyncContext;